import type { Lang } from './types';

/** Eventos de aplicação. Desacoplam store/i18n/sessão das features que redesenham. */
export interface AppEvents {
  /** O estado foi alterado e persistido: features redesenham. */
  state: void;
  /** Idioma trocado. */
  lang: Lang;
  /** Sessão entrou/saiu: shell decide o que mostrar. */
  session: void;
}

type Handler<K extends keyof AppEvents> = (payload: AppEvents[K]) => void;

class EventBus {
  private handlers = new Map<keyof AppEvents, Set<Handler<keyof AppEvents>>>();

  on<K extends keyof AppEvents>(event: K, handler: Handler<K>): () => void {
    let set = this.handlers.get(event);
    if (!set) { set = new Set(); this.handlers.set(event, set); }
    set.add(handler as Handler<keyof AppEvents>);
    return () => set!.delete(handler as Handler<keyof AppEvents>);
  }

  emit<K extends keyof AppEvents>(event: K, payload?: AppEvents[K]): void {
    this.handlers.get(event)?.forEach(h => h(payload as AppEvents[K]));
  }
}

export const bus = new EventBus();
